import React, {FC, useState} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, RoundButton, Text} from '@optimaxdev/design-system';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';

import {ContactsItemDetails} from 'components/success/contacts/contactsItemDetails/contactsItemDetails';
import {DetailToggle} from 'components/success/detailToggle/detailToggle';
import {StatusBlock} from 'components/success/statusBlock/statusBlock';
import {TYP_CONTACT_LENSES, TYP_INFO_BLOCK} from 'constants/analytics/events/typ';

import {getButtonText, getButtonLabel} from 'libs/success/helpers/helpers';
import {OrderDetailsItemsType} from 'types/orderDetailsTypes';

import {openDrawerAndSetItem} from '../../../store/reducers/drawerPopup/drawerPopup';

import {useSideEffects} from './sideEffects';

import s from './contactsItem.scss';

export type PropsType = {
    item: OrderDetailsItemsType;
};

/**
 * Contacts item for TYP
 */
export const ContactsItem: FC<PropsType> = ({item}) => {
    const {dispatch, isExamFetching, isVerification, items, shouldShowButton, type} =
        useSideEffects(item);

    const [isOpened, setIsOpened] = useState(false);

    const handleClick = () => {
        dispatch(openDrawerAndSetItem({item, title: getButtonText(type) || ''}));
        sendDesktopAnalyticsEvent(TYP_INFO_BLOCK, {
            blockName: 'Contact Lenses',
            label: `${getButtonLabel(type)} - ${getButtonText(type)}`,
        });
    };

    const handleToggle = () => {
        sendDesktopAnalyticsEvent(TYP_CONTACT_LENSES, 'See details');
        setIsOpened(v => !v);
    };

    return (
        <div>
            <div className={s.buttonWrapper}>
                <div className={s.header}>
                    <div className={s.imageWrapper}>
                        <CloudinaryImage
                            alt={item.name}
                            className={s.img}
                            src={item.product.image}
                            width="100%"
                        />
                    </div>
                    <div>
                        <Text
                            as="p"
                            color={Colors.blueCharcoal}
                            lineHeight="24px"
                            margin="0 0 6px"
                            size="16px"
                            bold
                        >
                            {item.windowName}
                        </Text>
                        <StatusBlock isFetching={isExamFetching} isVerification={isVerification} />
                        <DetailToggle isOpened={isOpened} toggleOpen={handleToggle} />
                    </div>
                </div>
                {shouldShowButton && type && (
                    <div className={s.btn}>
                        <RoundButton onClick={handleClick} size="small">
                            {getButtonText(type)}
                        </RoundButton>
                    </div>
                )}
            </div>
            <ContactsItemDetails isOpened={isOpened} item={item} items={items} />
        </div>
    );
};
